// extracted by mini-css-extract-plugin
module.exports = {"header":"Z_bf","root":"Z_cx","backTo":"Z_dV","getLink":"Z_fz","buttonLink":"Z_fB","markdownStyles":"Z_dW"};